import { z } from 'zod';

export const createCategorySchema = z.object({
  module_id: z.uuid('Invalid module ID'),
  parent_id: z.uuid('Invalid parent ID').optional().nullable(),
  slug: z
    .string()
    .min(1, 'Slug is required')
    .max(120, 'Slug must be less than 120 characters')
    .regex(/^[a-zA-Z0-9-]+$/, 'Slug must contain only letters, numbers, and hyphens'),
  label: z.string().min(1, 'Label is required').max(255, 'Label must be less than 255 characters'),
  is_active: z.boolean().optional().default(true),
  metadata: z.record(z.string(), z.unknown()).optional().default({}),
});

export type CreateCategoryPayload = z.infer<typeof createCategorySchema>;
export type CreateCategoryInput = z.input<typeof createCategorySchema>;
